import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadResource, changeI18nLanguage } from '../lang/lang';

loadResource().then(() => {
  changeI18nLanguage('ms-my');
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
